import Keycloak, {KeycloakLoginOptions, KeycloakPromise} from 'keycloak-js';
import {AuthLifecycle, AuthStrategy} from './auth-strategy.types';
import {AuthState, Profile} from './auth.types';

const KEYCLOAK_CONFIG_PATH = '/keycloak.json';
const MIN_TOKEN_VALIDITY_SECONDS = 5;

export class KeycloakAuthStrategy implements AuthStrategy {
  private readonly client: Keycloak;

  public constructor(private readonly lifecycle: AuthLifecycle) {
    this.client = new Keycloak(KEYCLOAK_CONFIG_PATH);

    this.client.init({
      onLoad: 'check-sso',
    });

    this.client.onReady = (authenticated: boolean) => {
      this.lifecycle.initialized.next(true);
      this.lifecycle.authenticated.next(authenticated);
    };

    this.client.onAuthSuccess = () => {
      this.lifecycle.authenticated.next(true);
    };

    this.client.onAuthError = () => {
      this.lifecycle.authenticated.next(false);
    };

    this.client.onAuthRefreshError = () => {
      this.client.clearToken();
      this.logout();
    };
  }

  public login(options?: KeycloakLoginOptions): void {
    this.client.login(options);
  }

  public logout(): void {
    this.client.logout();
  }

  public updateToken(): KeycloakPromise<boolean, boolean> {
    return this.client.updateToken(MIN_TOKEN_VALIDITY_SECONDS);
  }

  public get authState(): AuthState {
    return {
      accessToken: this.client.token,
      refreshToken: this.client.refreshToken,
      idToken: this.client.idToken,
    };
  }

  public get userProfile(): Profile {
    return {
      preferredName: this.client.tokenParsed?.name,
      department: this.client.tokenParsed?.azp,
      avatarUrl: this.client.tokenParsed?.avatarUrl,
    };
  }
}
